import Stack  from '@mui/joy/Stack';
import Tooltip from '@mui/joy/Tooltip';
import Typography from '@mui/joy/Typography';
import Button from '@mui/joy/Button';

import { Duration } from 'components/Date';
import { CollabProps } from 'stores/collab_store';

import useClock from 'hooks/useClock';
import useUserIdentity from 'hooks/useUserIdentity';
import getIcon from 'utils/getIcon';

function ClockInOutWidget({ collab }: { collab: CollabProps }) {
    const { currentClock, clockIn, clockOut } = useClock();
    const { currentIdentity } = useUserIdentity();
    const ClockInIcon = getIcon('PunchClock');
    const ClockOutIcon = getIcon('PunchClockOutlined');

    // clients don't need this
    if (currentIdentity?.role != 'assistant')
        return null;

    function doClockIn() {
        if (currentIdentity && collab.uuid) {
            clockIn(collab.uuid, '');
        }
    }

    function doClockOut() {
        console.log("clocking out: %s", currentClock?.uuid);
        if (currentClock?.uuid) {
            clockOut(currentClock.uuid);
        }
    }

    return (
        <Stack>
            {currentClock?.associated_uuid == collab?.uuid &&

                <Tooltip arrow placement="left" title="Clock out of this collab">
                    <Button
                        variant="outlined"
                        color="success"
                        startDecorator={<ClockOutIcon />}
                        onClick={doClockOut}>
                        <Stack pl={1}>
                            <Duration
                                start={currentClock?.time_start || ''}
                                end={currentClock?.time_end || ''} />
                            <Typography
                                whiteSpace="nowrap"
                                display={{ xs: 'none', md: 'none' }}
                                level="body-xs">Clock Out</Typography></Stack>
                    </Button>
                </Tooltip>
            }

            {currentClock?.associated_uuid != collab?.uuid &&
                <Tooltip arrow placement="left" title="Clock in right here">
                    <Button
                        variant="plain"
                        endDecorator={<ClockInIcon />}
                        onClick={doClockIn}>
                        <Typography
                            level="body-xs"
                            whiteSpace="nowrap">
                            Clock In Now
                        </Typography>
                    </Button>
                </Tooltip>
            }
        </Stack>
    );
}

export default ClockInOutWidget;
